// extracted by mini-css-extract-plugin
export default {"ContainerPrincipal":"estilo_ContainerPrincipal__8yRcv","titulo":"estilo_titulo__5tmO+"};